import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from '@gympass/yoga'

import { Check } from '@assets/icons'

import useBenefits from './Benefits.state'

import * as Style from '../../Home.style'
import BenefitsWrapper from './Benefits.style'

export default function About() {
  const { benefitsForCompanies, benefitsForEmployees } = useBenefits()

  return (
    <BenefitsWrapper>
      <Style.Container>
        <Style.Title thin>
          <FormattedMessage
            id="smb_acquisition_home.benefits.title"
            values={{
              strong: (...chunks) => <strong>{chunks}</strong>,
            }}
          />
        </Style.Title>

        <Row>
          <Col xxs={12} xl={5}>
            <Style.ListTitle>
              <FormattedMessage id="smb_acquisition_home.benefits.company.title" />
            </Style.ListTitle>
            <Style.ListWrapper divided={false}>
              {benefitsForCompanies.map(item => (
                <Style.ListItem key={item.id}>
                  <Style.ListItemIcon>
                    <img src={Check} alt="" />
                  </Style.ListItemIcon>
                  <Style.ListItemContent>
                    <Style.ListItemTitle>{item.title}</Style.ListItemTitle>
                    <Style.ListItemDescription>
                      {item.description}
                    </Style.ListItemDescription>
                  </Style.ListItemContent>
                </Style.ListItem>
              ))}
            </Style.ListWrapper>
          </Col>
          <Col xxs={12} xl-start={7} xl={5}>
            <Style.ListTitle>
              <FormattedMessage id="smb_acquisition_home.benefits.employee.title" />
            </Style.ListTitle>
            <Style.ListWrapper divided={false}>
              {benefitsForEmployees.map(item => (
                <Style.ListItem key={item.id}>
                  <Style.ListItemIcon>
                    <img src={Check} alt="" />
                  </Style.ListItemIcon>
                  <Style.ListItemContent>
                    <Style.ListItemTitle>{item.title}</Style.ListItemTitle>
                    <Style.ListItemDescription>
                      {item.description}
                    </Style.ListItemDescription>
                  </Style.ListItemContent>
                </Style.ListItem>
              ))}
            </Style.ListWrapper>
          </Col>
        </Row>
      </Style.Container>
    </BenefitsWrapper>
  )
}
